module.exports = __webpack_public_path__ + "static/5-d09384042c90b0f959ba781a0c06f6c3.jpg";